import { render } from "./DeliveryBreakRow.vue?vue&type=template&id=583f8dae&scoped=true"
import script from "./DeliveryBreakRow.vue?vue&type=script&lang=js"
export * from "./DeliveryBreakRow.vue?vue&type=script&lang=js"

import "./DeliveryBreakRow.vue?vue&type=style&index=0&id=583f8dae&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-583f8dae"]])

export default __exports__